import type { FaqItem } from '../components/Faq'

// One list shared by the home page and /pricing, so the two can never
// disagree (website-improvement items 10 and 11). Answers are drafts for
// the owner to approve; the POPIA answer needs the lawyer check before
// launch. Sources: whatsapp_consent.py, payment_claims.py, payments.py
// (cancel at period end), accounting.py (Xero scopes are read-only; the
// QuickBooks scope is one broad permission but the code only reads).
export const SHARED_FAQ: FaqItem[] = [
  {
    question: 'Who sends the message?',
    answer:
      "Reminders come from the RemindLoop WhatsApp number, and the message names your business. When a customer replies, the reply appears in your RemindLoop account.",
  },
  {
    question: 'Do customers have to agree first?',
    answer:
      'Your business needs their permission to message them on WhatsApp. When you set up, you tell us either that your customers already agreed, or that we should ask them first. If we ask first, we send each customer an SMS with a link to confirm. You are responsible for the permission; we cannot check it. Anyone can reply STOP at any time and we stop. SMS is also the backup when WhatsApp cannot reach a customer.',
  },
  {
    question: 'What about POPIA and my data?',
    answer:
      'We store only what is needed to send reminders: customer names, phone numbers, invoice details and a log of every message. You can ask us to delete your data.',
  },
  {
    question: 'Can RemindLoop change my Xero or QuickBooks?',
    answer:
      'RemindLoop only reads your invoices and their payment status. It does not create or change anything in Xero or QuickBooks.',
  },
  {
    question: 'What happens when a customer replies?',
    answer:
      'The reply shows in your RemindLoop account next to that customer. If a customer taps the "I\'ve paid" button, reminders for that invoice pause for a few business days while you check.',
  },
  {
    question: 'Can I cancel?',
    answer:
      'Yes. You can cancel at any time. Your plan stays active until the end of the period you have paid for, monthly or annual.',
  },
  {
    question: 'What about CSV imports?',
    answer:
      'CSV imports have no ledger to check, so reminders continue until you mark the invoice paid.',
  },
]
